import React from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import routes from './config/settings/routes'
import NotFoundPage from './pages/NotFound'
import PartnershipCertificatePage from './pages/PartnershipCertificate'
import RegisterWizardPage from './pages/RegisterWizard'
import TaxesKeyAuthPage from './pages/TaxesKeyAuth'
import ForeignRegisterWizardPage from './pages/ForeignRegisterWizard'
import UniquePassAuthPage from './pages/UniquePassAuth'
import UnsubscribePage from './pages/Unsubscribe'
import UniquePassAuthLogoutPage from './pages/UniquePassAuthLogout'

/**
 * The Routing's component.
 */
const Routing = () => (
  <BrowserRouter>
    <Routes>
      <Route caseSensitive element={<RegisterWizardPage />} path={routes.root} />
      <Route caseSensitive element={<RegisterWizardPage />} path={routes.registerWizard} />
      <Route caseSensitive element={<TaxesKeyAuthPage />} path={routes.taxesKeyAuth} />
      <Route caseSensitive element={<ForeignRegisterWizardPage />} path={routes.foreignRegisterWizard} />
      <Route caseSensitive element={<UniquePassAuthPage />} path={routes.uniquePassAuth} />
      <Route caseSensitive element={<PartnershipCertificatePage />} path={routes.partnershipCertificate} />
      <Route caseSensitive element={<PartnershipCertificatePage />} path={routes.partnershipCertificateSTU} />
      <Route caseSensitive element={<UnsubscribePage />} path={routes.unsubscribe} />
      <Route element={<NotFoundPage />} path="*" />
      <Route caseSensitive element={<UniquePassAuthLogoutPage />} path={routes.uniquePassAuthLogout} />
    </Routes>
  </BrowserRouter>
)

export default Routing
